import React from "react";

export const Card = ({ children, className = "", ...rest }) => (
  <div className={`rc-card rc-card-padded ${className}`} {...rest}>{children}</div>
);

export const StatCard = ({ label, value, sub, accent, testId }) => (
  <div className="rc-card rc-card-padded" data-testid={testId}>
    <div className="rc-caption uppercase tracking-wider">{label}</div>
    <div className="mt-2 rc-title-1 rc-tabular" style={{ color: accent || "var(--rc-label-primary)" }}>{value}</div>
    {sub && <div className="mt-1 rc-footnote">{sub}</div>}
  </div>
);

export const Pill = ({ tone = "grey", children, className = "" }) => (
  <span className={`rc-pill rc-pill-${tone} ${className}`}>{children}</span>
);

export const StatusPill = ({ status }) => {
  const map = {
    paid: ["success", "Paid"],
    available: ["success", "Available"],
    completed: ["success", "Completed"],
    resolved: ["success", "Resolved"],
    closed: ["grey", "Closed"],
    in_progress: ["blue", "In Progress"],
    open: ["blue", "Open"],
    due: ["warning", "Due"],
    overdue: ["destructive", "Overdue"],
    breached: ["destructive", "Breached"],
    upcoming: ["grey", "Upcoming"],
    pending: ["warning", "Pending"],
  };
  const [tone, label] = map[status] || ["grey", status];
  return <Pill tone={tone}>{label}</Pill>;
};

export const PriorityDot = ({ priority }) => {
  const cls = priority ? `rc-dot rc-dot-${priority.toLowerCase()}` : "rc-dot rc-dot-p4";
  return <span className={cls} title={priority} />;
};

export const Skeleton = ({ h = 16, w = "100%", r = 8, className = "" }) => (
  <div className={`rc-skeleton ${className}`} style={{ height: h, width: w, borderRadius: r }} />
);

export const Empty = ({ icon: Icon, title, subtitle, action }) => (
  <div className="flex flex-col items-center justify-center py-16 px-6 text-center">
    {Icon && <Icon size={56} strokeWidth={1.5} className="text-[#c7c7cc]" />}
    <div className="rc-title-3 mt-4">{title}</div>
    {subtitle && <div className="rc-footnote mt-2 max-w-sm">{subtitle}</div>}
    {action && <div className="mt-5">{action}</div>}
  </div>
);

export const ProgressRing = ({ value = 0, size = 160, stroke = 14, color = "#F9A61C" }) => {
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const off = c * (1 - value / 100);
  return (
    <div className="relative inline-block" style={{ width: size, height: size }}>
      <svg width={size} height={size} className="block">
        <defs>
          <linearGradient id="rcRing" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#F9A61C" />
            <stop offset="100%" stopColor="#F27024" />
          </linearGradient>
        </defs>
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="#F2F2F7" strokeWidth={stroke} />
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="url(#rcRing)" strokeWidth={stroke}
          strokeDasharray={c} strokeDashoffset={off} strokeLinecap="round"
          transform={`rotate(-90 ${size / 2} ${size / 2})`}
          style={{ transition: "stroke-dashoffset 800ms ease-out" }}
        />
      </svg>
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
        <div className="rc-tabular" style={{ fontSize: size * 0.24, fontWeight: 700, color: "#000", lineHeight: 1 }}>
          {Math.round(value)}<span style={{ fontSize: size * 0.14, color: "var(--rc-label-secondary)" }}>%</span>
        </div>
      </div>
    </div>
  );
};
